import styled from 'styled-components';
import MFlexbox from '../../atoms/MFlexbox';

export const StyledPopupOfferActionButtonsCon = styled(MFlexbox)`
  &.mr-popup-offer-actions--horizontal-full-width {
    width: 100%;
    max-width: 100%;
  }

  &.mr-popup-offer-actions--horizontal > *:not(.mr-actions--absolute-width) {
    min-width: fit-content;
    flex: 1 1 auto;
  }
`;
